const MetricCard = ({ label, value, note, tone = "neutral" }) => <article className={`director-module1__metric director-module1__metric--${tone}`}>
  <span>{label}</span>
  <strong>{value}</strong>
  {note && <small>{note}</small>}
</article>;

export default MetricCard;
